const flushers = new Map<() => Promise<void>, () => HTMLElement | null>();

export const registerRemixEditFlusher = (
	getElement: () => HTMLElement | null,
	flush: () => Promise<void>,
): (() => void) => {
	flushers.set(flush, getElement);
	return () => {
		flushers.delete(flush);
	};
};

/** Wait for this editor's embeds before its final collab snapshot is read. */
export const flushPendingRemixEdits = async (editor: HTMLElement): Promise<void> => {
	await Promise.all(
		Array.from(flushers, ([flush, getElement]) => {
			const element = getElement();
			return element && editor.contains(element) ? flush() : undefined;
		}),
	);
};
